import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function AlertTriangle($$anchor, $$props) {
	const iconNode = [
		[
			"path",

			{
				"d": "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"
			}
		],

		["path", { "d": "M12 9v4" }],
		["path", { "d": "M12 17h.01" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiQWxlcnRUcmlhbmdsZS5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJtMjEuNzMgMTgtOC0xNGEyIDIgMCAwIDAtMy40OCAwbC04IDE0QTIgMiAwIDAgMCA0IDIxaDE2YTIgMiAwIDAgMCAxLjczLTNcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0xMiA5djRcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0xMiAxN2guMDFcIiB9XV07XG4gIGxldCByZXN0ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cbjxJY29uIHtpY29uTm9kZX0gey4uLnJlc3R9IC8+XG4iXSwibWFwcGluZ3MiOiI7O09BQ1MsSUFBSSxNQUFNLGVBQWU7O3lEQURsQyxDQUFDO09BRU8sUUFBNEM7O0dBQUssTUFBTTs7O0lBQUksR0FBRyxFQUFFLDBFQUEwRTs7OztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsU0FBUztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsWUFBWTs7O0tBQzNNLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9